import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IArticleParagraphProps } from '../components/article-paragraph/article-paragraph';

export class ArticleParagraphModel extends ContentItem {
  get number(): string {
    return get(this._config, 'elements.number.value', '');
  }

  get content(): string {
    return get(this._config, 'elements.content.value', '');
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get removeMarginTop(): boolean {
    return (
      get(this._config, 'elements.margin_top.value[0].codename') === 'true'
    );
  }

  public static create(data: IArticleParagraph): IArticleParagraphProps {
    const {
      number,
      content,
      title,
      removeMarginTop
    } = new ArticleParagraphModel(data);
    return {
      number,
      content,
      title,
      removeMarginTop
    };
  }
}
